import { render, staticRenderFns } from "./UploadPartBody.vue?vue&type=template&id=45cafba9&"
import script from "./UploadPartBody.vue?vue&type=script&lang=js&"
export * from "./UploadPartBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports